import { Ref, ref, watch } from "vue";

interface IPaymentPopupQueueItem {
	isShowBlockWarning: boolean;
	isModalVisible: boolean;
	wasModalShowed: boolean;
	showModal: () => void;
	hideModal: () => void;
}

export class PaymentPopupQueueController {
	private _queue: Ref<IPaymentPopupQueueItem[]> = ref([]);

	public addPopup(item: IPaymentPopupQueueItem) {
		this._queue.value.push(item);
		return this;
	}

	public start() {
		if (this._queue.value.length > 0) {
			this.processNextPopup();
		}
	}

	private processNextPopup() {
		if (this._queue.value.length === 0) return;

		const item = this._queue.value[0];

		if (!item.wasModalShowed) {
			item.showModal();

			const stopWatch = watch(
				() => item.isModalVisible,
				(newVal) => {
					if (!newVal) {
						stopWatch();
						this._queue.value.shift();
						this.processNextPopup();
					}
				}
			);
		}
	}
}
